import { Env2 } from '@toy/utils';

// 环境枚举
export enum ENV_ENUM {
  DEV = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PROD = 'prod',
}

// 系统枚举
export enum SYSTEM_ENUM {
  'NEST_API' = 'nest-api',
  'ARSENAL_API' = 'arsenal-api',
  'LOGIN_WEB' = 'login-web',
}

export const envInstance = new Env2<ENV_ENUM, SYSTEM_ENUM>({
  onlineEnv: window.$frontEnv,
  /* 本地环境 使用环境 */
  localEnv: ENV_ENUM.DEV,
  onlineDomain: 'tiangong.tech',
  localDomain: 'tiangong.tech',
});

// 获取 api 前置路径
export const { API_BASE, currentEnv } = envInstance;
export const currentSystem = window.$system as string || 'nest';
export const ENV_PREFIX = window.location.host;
